import cn from 'clsx'
import React, { PropsWithChildren } from 'react'
import styled, { withTheme } from 'styled-components'

import { SVG_ICON_SIZE_CSS_VAR, StyledSvgIcon } from 'components/Luxkit/SvgIcon'

export const CIRCULAR_PIN_SIZE = 24

const StyledSvg = styled.svg`
  pointer-events: none;
  color: ${(props) => props.theme.palette.brand.primary.normal};
  overflow: visible;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }

  &.isActive {
    color: ${(props) => props.theme.palette.highlight.secondary.normal};
  }
`

const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > ${StyledSvgIcon} {
    ${SVG_ICON_SIZE_CSS_VAR}: 100%;
  }
`

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;
`

interface Props {
  isActive?: boolean
  theme: App.Theme
}

function CircularPin({ theme, isActive, children }: PropsWithChildren<Props>) {
  return (
    <Container>
      <StyledSvg
        className={cn({ isActive })}
        height={CIRCULAR_PIN_SIZE}
        width={CIRCULAR_PIN_SIZE}
        viewBox="0 0 24 24"
      >
        <path
          d="M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z"
          fill="currentColor"
          stroke={theme.palette.neutral.default.eight}
        />
      </StyledSvg>

      <IconContainer>{children}</IconContainer>
    </Container>
  )
}

export default withTheme(React.memo(CircularPin))
